import tokens from '../../../utils/tokens'
import {userAuthorization} from '../../../stores/auth'
import {setCustomerData} from '../../../stores/sidebar'
import {applyVoucher, setDisableTutorial} from '../../../stores/voucher'
import localStorageKeys from '../../../utils/localStorageKeys'
import {routes} from '../../../routes'
import NavigationHelper from '../../../utils/navigation'
import {useEffect} from 'react'
import {setIsFirstLogin} from '../../../stores/resources'
import {useSearchParams, useNavigate} from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux'
import AuthService from '../../../api/auth'
import statusCodes from '../../../utils/http'

const Authorization = () => {
    const navigate = useNavigate()
    const isAuthenticated = useSelector(state => state.auth.isAuthenticated)
    const isSignedUpWithPlan = location.search.includes('plan') && location.search.includes('interval')
    const [searchParams] = useSearchParams()
    const clientId = searchParams.get('client_id')
    const redirectUri = searchParams.get('redirect_uri')
    const state = searchParams.get('state')
    const scopes = searchParams.get('scope')
    const responseType = searchParams.get('response_type')
    const dispatch = useDispatch()
    const checkIsFirstLogin = () => {
        if (window.location.href.includes('is_first_login=true') && !isSignedUpWithPlan) {
            dispatch(setIsFirstLogin(true))
            localStorage.setItem(localStorageKeys.NO_RESOURCE_CREATED_KEY, true)
        }
    }

    const setupUserAndCustomerData = async() => {
        await dispatch(userAuthorization(navigate, {customer_id: localStorage.getItem('customerId')}))
        dispatch(setCustomerData())
    }

    const doComponentDidMountProcesses = async() => {
        try {
            let exchangeKey = searchParams.get('exchange_key')

            if (exchangeKey) {
                const refreshTokenData = await AuthService.getRefreshToken(exchangeKey)

                localStorage.clear()
                const refreshToken = refreshTokenData.data?.data?.token
                const customerId = searchParams.get('customer_id')

                localStorage.setItem(tokens.refreshToken.key, refreshToken)
                localStorage.setItem('customerId', customerId)

                await dispatch(userAuthorization(navigate, {
                    customer_id: customerId
                }))
                dispatch(setCustomerData())
                checkIsFirstLogin()

                if (location.search.includes('voucher')) {
                    dispatch(setDisableTutorial(true))
                    const voucher = searchParams.get('voucher')
                    localStorage.setItem('voucher', voucher)
                    await dispatch(applyVoucher({
                        code: voucher
                    }))
                }

                if (location.search.includes('coupon')) {
                    const coupon = searchParams.get('coupon')
                    localStorage.setItem('coupon', coupon)
                    window.location.href = `${NavigationHelper.getLocalizedPath(routes.plans.paths)}?coupon=${coupon}`
                }

                if (clientId && redirectUri && state && responseType && scopes) {
                    window.location.href = `${NavigationHelper.getLocalizedPath(routes.oauth_integration.paths)}?client_id=${clientId}&redirect_uri=${redirectUri}&state=${state}&scope=${scopes}&response_type=${responseType}`
                }

                if (isSignedUpWithPlan) {
                    localStorage.setItem(localStorageKeys.SHOW_TUTORIALS_AFTER_PAYMENT, true)
                    return
                }

                if (window.location.pathname) {
                    window.history.pushState({}, document.title, window.location.pathname)
                    return
                }

                window.history.pushState({}, document.title, NavigationHelper.getLocalizedPath(routes.resources.paths))
                return
            }

            if (!isAuthenticated &&
                localStorage.getItem(tokens.token.key) &&
                !location.search.includes(exchangeKey)) {
                await setupUserAndCustomerData()
                return
            }

            if (!isAuthenticated) {
                NavigationHelper.navigateToSignIn()
            }
        } catch (error) {
            const status = error.response?.status

            if (status && statusCodes.SpecialErrors.includes(status) && localStorage.getItem(tokens.token.key)) {
                await setupUserAndCustomerData()
                return
            }

            NavigationHelper.navigateToSignIn()
        }
    }

    useEffect(() => {
        doComponentDidMountProcesses()
    }, [])
}

export default Authorization
